var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "alert-container" }, [
        _c(
          "div",
          {
            staticClass: "alert",
            class: ["alert-" + _vm.alertType, "alert-" + _vm.context]
          },
          [
            _c(
              "div",
              { staticClass: "alert-icon" },
              [
                _c("NsIcon", {
                  staticStyle: { width: "30px", height: "30px" },
                  attrs: { "icon-name": _vm.icon, color: _vm.color }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "alert-head" }, [
              _c(
                "h4",
                { staticClass: "title-small-bold" },
                [
                  _vm._t("head", [
                    _vm._v(
                      "\n          " + _vm._s(_vm.titleText) + "\n        "
                    )
                  ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _vm.hasDismissListener
              ? _c("div", { staticClass: "alert-close-button" }, [
                  _c("span", [
                    _c(
                      "svg",
                      {
                        attrs: {
                          viewBox: "0 0 12 12",
                          version: "1.1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("dismiss")
                          }
                        }
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              fill: "none",
                              stroke: "#000000",
                              "stroke-width": "1"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                d: "M 0 0 L 12 12 M 0 12 L 12 0"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "alert-content" }, [
              _c(
                "div",
                { staticClass: "alert-body p-medium" },
                [_vm._t("body")],
                2
              ),
              _vm._v(" "),
              _vm.$slots.foot
                ? _c(
                    "div",
                    { staticClass: "alert-foot p-small" },
                    [_vm._t("foot")],
                    2
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }